module.exports = "https://cdn.realtymogul.com/static/media/social_youtube_blue.150c05ea.svg";